// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';
import notify from '../utils/toast';
import AppModal from '../components/AppModal';
import { useAuth } from '../context/AuthContext';

export default function BookingDetail() {
    const { id } = useParams();
    const [booking, setBooking] = useState(null);
    const [ledger, setLedger] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showPay, setShowPay] = useState(false);
    const closePayModal = () => {
        setShowPay(false);
        setPayForm({ amount: '', payment_date: new Date().toISOString().slice(0, 10), payment_method: 'cash', notes: '', installment_id: '' });
    };
    const [payForm, setPayForm] = useState({ amount: '', payment_date: new Date().toISOString().slice(0, 10), payment_method: 'bank_transfer', reference: '', installment_id: '' });
    const { hasRole } = useAuth();

    const load = () => {
        setLoading(true);
        Promise.all([
            api.get(`/bookings/${id}`),
            api.get(`/bookings/${id}/ledger`),
        ]).then(([b, l]) => {
            setBooking(b.data.data);
            setLedger(l.data.data);
        }).finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, [id]);

    const submitPayment = async (e) => {
        e.preventDefault();
        try {
            await api.post('/payments', {
                booking_id: Number(id),
                ...payForm,
                amount: Number(payForm.amount),
                installment_id: payForm.installment_id || null,
            });
            closePayModal();
            load();
            notify.info('Payment submitted for approval');
        } catch (err) {
            notify.apiError(err);
        }
    };

    if (loading) return <div className="text-center py-5"><div className="spinner-border text-success" /></div>;
    if (!booking) return <div className="alert alert-warning">Booking not found</div>;

    return (
        <div>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/bookings">Bookings</Link></li>
                    <li className="breadcrumb-item active">{booking.booking_no}</li>
                </ol>
            </nav>

            <div className="d-flex justify-content-between align-items-start mb-4 flex-wrap gap-2">
                <div>
                    <h4 className="mb-1">{booking.booking_no}</h4>
                    <p className="text-muted mb-0">
                        {booking.project?.name} · Unit {booking.unit?.unit_number} · {booking.customer?.name}
                    </p>
                </div>
                <button className="btn btn-primary btn-sm" onClick={() => setShowPay(true)}>
                    <i className="bi bi-cash me-1"></i> Record Payment
                </button>
            </div>

            <div className="row g-3 mb-4">
                <div className="col-md-3">
                    <div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">Final Price</div>
                        <div className="fs-5 fw-bold">৳ {Number(booking.final_price).toLocaleString()}</div>
                    </div></div>
                </div>
                <div className="col-md-3">
                    <div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">Paid</div>
                        <div className="fs-5 fw-bold text-success">৳ {ledger?.summary?.total_paid?.toLocaleString()}</div>
                    </div></div>
                </div>
                <div className="col-md-3">
                    <div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">Due</div>
                        <div className="fs-5 fw-bold text-danger">৳ {ledger?.summary?.total_due?.toLocaleString()}</div>
                    </div></div>
                </div>
                <div className="col-md-3">
                    <div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">Status</div>
                        <div className="fs-5 fw-bold text-capitalize">{booking.status}</div>
                    </div></div>
                </div>
            </div>

            <div className="row g-3">
                <div className="col-lg-6">
                    <div className="card table-card">
                        <div className="card-header bg-white fw-semibold">Installment Schedule</div>
                        <div className="table-responsive">
                            <table className="table mb-0">
                                <thead className="table-light">
                                    <tr><th>#</th><th>Title</th><th>Due</th><th>Amount</th><th>Paid</th><th>Status</th></tr>
                                </thead>
                                <tbody>
                                    {(booking.installments || []).map((i) => (
                                        <tr key={i.id}>
                                            <td>{i.installment_no}</td>
                                            <td>{i.title}</td>
                                            <td>{i.due_date}</td>
                                            <td>৳ {Number(i.amount).toLocaleString()}</td>
                                            <td>৳ {Number(i.paid_amount).toLocaleString()}</td>
                                            <td><span className="badge bg-secondary badge-status">{i.status}</span></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card table-card">
                        <div className="card-header bg-white fw-semibold">Payment History</div>
                        <div className="table-responsive">
                            <table className="table mb-0">
                                <thead className="table-light">
                                    <tr><th>Receipt</th><th>Date</th><th>Amount</th><th>Method</th><th>Status</th></tr>
                                </thead>
                                <tbody>
                                    {(booking.payments || []).length === 0 ? (
                                        <tr><td colSpan={5} className="text-center text-muted py-3">No payments yet</td></tr>
                                    ) : (booking.payments || []).map((p) => (
                                        <tr key={p.id}>
                                            <td>{p.receipt_no}</td>
                                            <td>{p.payment_date}</td>
                                            <td>৳ {Number(p.amount).toLocaleString()}</td>
                                            <td className="text-capitalize">{p.payment_method?.replace('_', ' ')}</td>
                                            <td>
                                                <span className={`badge bg-${p.status === 'approved' ? 'success' : p.status === 'rejected' ? 'danger' : 'warning'} badge-status`}>
                                                    {p.status}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {showPay && (
                <div className="modal show d-block app-modal" onClick={closePayModal} style={{ background: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <form className="modal-content" onSubmit={submitPayment}>
                            <div className="modal-header">
                                <h5 className="modal-title">Record Payment</h5>
                                <button type="button" className="btn-close" onClick={closePayModal} />
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">Amount *</label>
                                    <input type="number" className="form-control" required value={payForm.amount} onChange={(e) => setPayForm({ ...payForm, amount: e.target.value })} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Installment (optional)</label>
                                    <select className="form-select" value={payForm.installment_id} onChange={(e) => setPayForm({ ...payForm, installment_id: e.target.value })}>
                                        <option value="">—</option>
                                        {(booking.installments || []).map((i) => (
                                            <option key={i.id} value={i.id}>{i.title} (Due {i.due_date})</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Date *</label>
                                    <input type="date" className="form-control" required value={payForm.payment_date} onChange={(e) => setPayForm({ ...payForm, payment_date: e.target.value })} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Method</label>
                                    <select className="form-select" value={payForm.payment_method} onChange={(e) => setPayForm({ ...payForm, payment_method: e.target.value })}>
                                        <option value="cash">Cash</option>
                                        <option value="bank_transfer">Bank Transfer</option>
                                        <option value="cheque">Cheque</option>
                                        <option value="mobile_banking">Mobile Banking</option>
                                        <option value="card">Card</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Reference / Txn ID</label>
                                    <input className="form-control" value={payForm.reference} onChange={(e) => setPayForm({ ...payForm, reference: e.target.value })} />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closePayModal}>Cancel</button>
                                <button type="submit" className="btn btn-primary">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
